import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {history, url} from '../../utils/variables';
import {firstBoot} from '../../redux/actions';
import Notifications from '../../components/pages/home/Notifications';
import HomeButton from '../../components/pages/home/Button';
import Switch from '../../components/master/Switch';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/master/Modal';
import logo from '../../assets/images/logo.png'
import alarm from '../../assets/images/alarm.gif';
import bell from '../../assets/images/bell.png';
import { pexios } from '../../utils/functions';
export default function Home() {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const dispatch = useDispatch();

    const { boot, user , language } = useSelector(store => store);

    const [userType, setUserType] = useState('culprit');
    const [componentLoaded, setComponentLoaded] = useState(false);
    const [openalert ,setOpenAlert] = useState(false);
    const [popup , setPopup] = useState([]);

    useEffect(() => {
        i18n.changeLanguage(language.lang || "fa");
        const isApplication = location.search;
        if (!boot && isApplication) {
            dispatch(firstBoot(true));
        } else if (!boot && !isApplication) {
			dispatch(firstBoot(true));
			history.replace('/login');
		}
        else if (user.type) {
            // if(user.type === 'expert' && user.id === 89957){

            //     navigator.geolocation.getCurrentPosition(
            //         position => {
            //             // dispatch(setLocation({
            //             //     lat: position.coords.latitude,
            //             //     lng: position.coords.longitude,
            //             // }));
            //             setGpsValue(1)
            //         },
            //         () => {
            //             // if(!permission){
            //             //     toast('لطفا برای دسترسی به موقعیت تنظیمات خود را مجددا بررسی کنید','error');
            //             //     setTimeout(()=>setPermission(true),30000)
            //             // }
            //             setGpsValue(0)
            //         },
            //         {enableHighAccuracy: true},
            //     );
            // }
            if(user.type === 'expert'){
                pexios('api/show-popup')
                 .then((res)=>{
                    if(res.data.type !== 'off'){
                        setOpenAlert(true)                  
                        setPopup(res.data)
                    } 
                })
            }
            setComponentLoaded(true);
        } else history.replace('/login');
    }, [boot, user, location.search, dispatch,language]);
    function closeAlert() {
        setOpenAlert(false)
        pexios('api/see-popup')
    }

    return (
        //componentLoaded &&
            <div className='d-flex flex-column flex1 home'>
                {/* <Notifications /> */}
                {componentLoaded && <Notifications />}
                {openalert && 
                <Modal visible={openalert}>
                    {/* <div className='alert-box p10'>                        
                        <span className='alert-icon'><i className='fas fa-bell'/></span>
                        <span className='close-btn'><i className='fas fa-times'/></span>
                        <p className='alert-title'>اطلاعیه جدید</p>
                        <img src={logo}/>
                        <p className='alert-text mt20 p10'>شرکت ارزیابی خسارت همراه بیمه خلیج فارس فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد</p>
                        <button className='btn btn-block btn-circle btn-green m10' onClick={()=> setOpenAlert(false)}>متوجه شدم</button>
                    </div> */}
                    {/* <div className='alert-box2'>
                        <span className='alert-icon mt20 mb20'>
                            <i className='fas fa-bell'/>
                            <img src={bell} style={{width : '25px'}} />
                            </span>
                        <div className='upper-card pt40 pb20'>
                        <span className='close-btn'><i className='fas fa-times'/></span>
                            
                        <img src={logo}/>
                        </div>
                    <p className='alert-text mt20 p20'>
                    شرکت ارزیابی خسارت همراه بیمه خلیج فارس فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد</p>
                    <div className='body-card m10'>
                        <button className='btn btn-block btn-circle m10' onClick={()=> setOpenAlert(false)}>متوجه شدم</button>
                        </div>
                    </div> */}
                    <div className='alert-box3'>
                        {popup.type === 'image' && 
                            <img className='alert-image' src ={`${url}/${popup.pop.address}`}/>
                        }
                        {popup.type === 'text' &&
                        <div className='upper-card'>
                            <img className='mt20 alert-icon' src={alarm}/>    
                            <p className='alert-text mt10 alert-title'>
                                {popup.pop.title} 
                                {/* مهدیه عزیز */}
                                </p>
                            <p className='alert-text mt20 pl15 pr15'>
                                {popup.pop.top} ,
                                {/* عنوان */}
                                </p>
                            <p className='alert-text p15'>
                                {popup.pop.text} 
                                {/* شرکت ارزیابی خسارت همراه بیمه خلیج فارس فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد */}
                                </p>
                            <p className='alert-text p15'>
                                {popup.pop.end} 
                                {/* از همکاری شما سپاس گزاریم */}
                                </p>
                        </div>
                            } 
                        <div className='footer-card'>
                            <button className='btn btn-block btn-circle m15' onClick={closeAlert}>{popup.type === 'image' ? t('Close') : t('Get it')}</button>
                        </div>
                    </div>
                </Modal> }
                
                {/* <div className='lists mb50'>
                    <div className='list-box'>
                        
                        <p className='mt10'> کل پرونده ها</p>
                        <div className='count-content mt10'>
                        
                        27
                        </div>
                        
                        <div className='list-title'>
                           
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box'>
                        <i className='fas fa-clone mt10 ml10'/>
                        <div className='count-content'>
                        
                        27
                        </div>
                        
                        <div className='list-title'>
                            <p> در حال کارشناسی</p>
                            <i className='fas fa-arrow-right'/> 
                        </div>
                    </div>
                    <div className='list-box'>
                        <i className='fas fa-clone mt10 ml10'/>
                        <div className='count-content'>
                        
                        27
                        </div>
                        
                        <div>
                            <p> کل پرونده ها</p>
                        </div>
                    </div>
                    <div className='list-box'>
                        <i className='fas fa-clone mt10 ml10'/>
                        <div className='count-content'>
                        
                        27
                        </div>
                        
                        <div>
                            <p> کل پرونده ها</p>
                        </div>
                    </div>
                    <div className='list-box'>
                        <i className='fas fa-clone mt10 ml10'/>
                        <div className='count-content'>
                        
                        27
                        </div>
                        
                        <div>
                            <p> کل پرونده ها</p>
                        </div>
                    </div>
                </div> */}


                {/* <div className='list2'>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        27
                        <p className='ml20'>کل پرونده ها</p>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex' style={{'backgroundColor':'#c6dd63'}}>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        27
                        <p className='ml20'>  در حال کارشناسی</p>
                        </div>
                        <div className='list-title'>
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex' style={{'backgroundColor': '#78df91'}}>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        27
                        <p className='ml20'>  تسویه شده</p>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                </div> */}

                {/* <div className='list3 '>
                <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        <p className='ml20'>کل پرونده ها</p>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        <p className='ml20'>کل پرونده ها</p>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        <p className='ml20'>کل پرونده ها</p>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                </div> */}
                {/* <div className='list4'>
                <div className='list-box'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                    <div className='list-box d-flex'>
                        <div className='box-icon'><i className='fas fa-clone mt10 ml10'/></div>
                        <div className='count-content d-flex'>
                        <h3>27</h3>
                        
                        </div>
                        <div className='list-title'>
                            
                            <i className='fas fa-arrow-right'/>                           
                        </div>
                    </div>
                </div> */}
                {user.type === 'user' &&
                <div className='flex1'>
                    {
                        user.type === 'user' &&
                        <Switch
                            value={userType}
                            labels={[
                                t('I am culprit'),
                                t('I am losses'),
                            ]}
                            values={[
                                'culprit',
                                'losses',
                            ]}
                            onChange={(value) => setUserType(value)}
                        />
                    }
                </div>
}
                <div className='homeButtonParent'>
                    <div className='homeButton'>
                        <HomeButton userType={userType} />
                    </div>
                </div>
                <div className='flex1'/>

            </div>
            
    )

}
